import { DataTableSortStatus } from 'mantine-datatable';
import { getParamName } from '../../../../../../common';

type GetSortValueOptionsType<T> = {
  searchParams: Record<string, unknown>;
  tableId?: string;
  defaultAccessor: keyof T;
  defaultDirection: DataTableSortStatus<T>['direction'];
};

export const getSortValue = <T>({
  searchParams,
  tableId,
  defaultAccessor,
  defaultDirection,
}: GetSortValueOptionsType<T>): string => {
  return (
    (searchParams?.[getParamName('sort', tableId)] as string | undefined) ??
    `${String(defaultAccessor)}:${defaultDirection}`
  );
};
